(function () {
  var UID = 'subscriptionplanshqt3f8';

  function init() {
    var wrap = document.querySelector('[id^="sticky-add-to-cart-"]');
    if (!wrap) return;

    var form = wrap.querySelector('form');
    if (!form) return;

    // Parse the variants JSON already embedded on the sticky div
    var variants = [];
    try { variants = JSON.parse(wrap.getAttribute('x-variants-data') || '[]'); } catch (e) {}

    // Given current select values, find the matching variant and update input[name="id"]
    function updateVariantFromSelects() {
      var selects = Array.from(wrap.querySelectorAll('select'));
      if (!selects.length || !variants.length) return;

      var match = variants.find(function (v) {
        return selects.every(function (sel, i) {
          var optVal = v['option' + (i + 1)];
          return optVal === sel.value;
        });
      });

      if (!match) return;

      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = String(match.id);
    }

    // Set selling_plan input from the subscription-plans widget selection
    function syncSellingPlan() {
      var panel = document.querySelector('.sub-plans__panel-' + UID + '.active');
      var opt   = panel && panel.querySelector('.sub-plans__option-' + UID + '.selected');
      var planId = (opt && opt.dataset.sellingPlanId || '').trim();

      var spInput = form.querySelector('input[name="selling_plan"]');
      if (planId) {
        if (!spInput) {
          spInput = document.createElement('input');
          spInput.type = 'hidden';
          spInput.name = 'selling_plan';
          form.appendChild(spInput);
        }
        spInput.value = planId;
      } else if (spInput) {
        spInput.parentNode.removeChild(spInput);
      }
    }

    // Sticky selects drive the variant independently
    wrap.addEventListener('change', function (e) {
      if (e.target.tagName === 'SELECT') updateVariantFromSelects();
    });

    // Right before click, also sync selling_plan from subscription widget
    document.addEventListener('mousedown', function (e) {
      if (wrap.querySelector('button[name="add"]') === e.target ||
          (e.target && e.target.closest && e.target.closest('[id^="sticky-add-to-cart-"] button[name="add"]'))) {
        syncSellingPlan();
      }
    });

    // Initial state
    updateVariantFromSelects();
    syncSellingPlan();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
